export const CARD_FOOTER_MAX_ALLOWED_BUTTONS = 2;
